import { CoreConfig } from '../types/store'

const BASE_URL =
  process.env.REACT_APP_STORE_LIST ??
  'https://sss-api.fcemea.instore.oakley.com'

type FetchErrorOptions = {
  defaultMessage: string
}

async function fetchJson<T>(
  url: string,
  { defaultMessage }: FetchErrorOptions
): Promise<T> {
  const response = await fetch(url)

  if (!response.ok) {
    throw new Error(
      `${defaultMessage}: ${response.status}:${response.statusText}`
    )
  }

  return response.json()
}

export default class StoreListServices {
  static async getCoresList(): Promise<CoreConfig[]> {
    const errorMessage = 'Something went wrong while fetching the store cores'

    try {
      const result = await fetchJson<{
        data: { cores: CoreConfig[] }
      }>(`${BASE_URL}/api/v1/config/cores`, { defaultMessage: errorMessage })

      return result.data.cores
    } catch (error: any) {
      throw new Error(error?.message || errorMessage)
    }
  }

  static async getStoreNames(core: string): Promise<string[]> {
    const errorMessage = 'Something went wrong while fetching the store names'

    try {
      const result = await fetchJson<{
        data: {
          facet: {
            counts: { name: string }[]
          }
        }
      }>(`${BASE_URL}/api/v1/get/facets/${core}/stores`, {
        defaultMessage: errorMessage,
      })

      return result.data.facet.counts.map(({ name }) => name)
    } catch (error: any) {
      throw new Error(error?.message || errorMessage)
    }
  }
}
